<template>
    <a class="nav-link" :href="urlWishList" rel="nofollow" :aria-label="$translate('Ceres::Template.wishList')">
        <span class="badge-right d-none">{{ wishListCount }}</span>
        <img :src="$translate('babyVueTheme::Header.HeartIcon')" alt="wishList" class="img-fluid d-block mx-auto">
	 <span class="sub-menu d-block">{{ $translate("Ceres::Template.wishList") }}</span>
    </a>
</template>

<script>
export default {
    computed:
    {
        wishListCount()
        {
            return this.$store.getters.wishListCount;
        },

        urlWishList()
        {
            return App.urls.wishList;
        }
    }
}
</script>
